import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-slate-50 px-6"
      data-testid="not-found-page"
    >
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-6">
          <Compass className="h-8 w-8 text-slate-500" />
        </div>
        <h1 className="text-4xl font-semibold text-slate-900 mb-3" data-testid="not-found-title">
          404 — Page not found
        </h1>
        <p className="text-slate-600 mb-8">
          The link may be out of date or the page has moved. OnSiteHand is now free to use —
          head to the home page or search tradespeople directly.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 text-white font-medium hover:bg-slate-700 transition-colors"
            data-testid="not-found-home-link"
          >
            <ArrowLeft className="h-4 w-4" />
            Back home
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-5 py-2.5 text-slate-700 font-medium hover:bg-slate-100 transition-colors"
            data-testid="not-found-search-link"
          >
            Search tradespeople
          </Link>
        </div>
      </div>
    </div>
  );
}
